import { NSARouterMakerResult } from "namirasoft-account-react";
import { FilterItem, FilterItemOperator } from "namirasoft-core";
import { EnvironmentRow, ProjectRow } from "namirasoft-infra";
import { NamirasoftMap } from "namirasoft-site-map";
import { NSBox, NSCard, NSColumn, NSLinkBlue, NSLoading, NSNoData, NSRow, NSTitle } from "namirasoft-site-react";
import { useEffect, useState } from "react";
import { InfraCacheService } from "../InfraCacheService";
import { InfraImages } from "../InfraImages";
import { InfraRouterProps } from "../InfraRouterProps";
import { InfraRoutes } from "../InfraRoutes";

export interface EnvironmentListProps extends NSARouterMakerResult, InfraRouterProps
{
    project_id: string;
}
export interface EnvironmentListState
{
    loading: boolean;
    project?: ProjectRow;
    environments?: EnvironmentRow[];
}

function EnvironmentList(props: EnvironmentListProps)
{
    let [state, setState] = useState<EnvironmentListState>({ loading: true });

    useEffect(() =>
    {
        load();
        // eslint-disable-next-line
    }, []);

    let load = async () =>
    {
        let namirasoft = new NamirasoftMap(props.account.token_manager, console.error);

        let filters = [new FilterItem(
            namirasoft.infra.tables.environment,
            namirasoft.infra.tables.environment.columns.project_id,
            false,
            FilterItemOperator.all.equals,
            props.project_id,
        )];

        try
        {
            let cache = InfraCacheService.getProject(props.project_id, props.servers.infra);
            let project = await cache.get();
            let environments = await props.servers.infra.environment.List(filters, 1, 100, [], null);
            setState(() => ({ project, environments: environments.rows, loading: false }));
        }
        catch (error)
        {
            props.notifier.onError(error as Error);
            setState(() => ({ loading: false }));
        }
    }

    return (
        <>
            {
                state.loading &&
                <NSLoading />
            }
            {
                state.project &&
                <NSTitle title={state.project.name + " Environment List"} classList={["mb-4"]} style={{ fontSize: "1.5rem" }} />
            }
            <NSRow>
                {
                    state.environments?.map(env => (
                        <NSCard
                            key={env.id}
                            title={env.name}
                            description={env.description ?? undefined}
                            image={{ src: InfraImages.environment, alt: "Environment" }}
                            link={{ href: InfraRoutes.ProjectDiagram(props.project_id, env.id), target: "_self" }}
                        />
                    ))
                }
            </NSRow>
            {
                !state.loading && (!state.environments || state.environments.length < 1) &&
                <NSColumn classList={["align-items-center"]}>
                    <NSNoData lable="There is no environment." classList={["pb-4 rounded-4"]} style={{ maxWidth: NSBox.width.double }} />
                    <NSLinkBlue href={InfraRoutes.EnvironmentNew}>Create your first environment</NSLinkBlue>
                </NSColumn>
            }
        </>
    );
}

export default EnvironmentList;